export const GET_PERSONAL_DIVISION = 'GET_PERSONAL_DIVISION';
export const LOADING_PERSONAL_DIVISION = 'LOADING_PERSONAL_DIVISION';
export const SAVE_LOADER_PERSONAL_DIVISION= 'SAVE_LOADER_PERSONAL_DIVISION'
export const FORM_FAIL = "FORM_FAIL";
export const PERSONAL_DIVISION_FAIL = 'PERSONAL_DIVISION_FAIL';